/* eslint-disable @typescript-eslint/naming-convention */
import {AbstractApiRequestInterceptor} from 'core/abstract/AbstractApiRequestInterceptor';
import {IRequestOptions, TJson, TRequestParameters} from 'core/types';
import {isBrowserContext} from 'core/helpers';
import {getClientIpFromContext} from 'core/helpers/clientIp';

/**
 * Интерцептор для добавления IP-адреса клиента в заголовки запросов
 * Работает только на сервере (не в браузере)
 */
export class ClientIpRequestInterceptor extends AbstractApiRequestInterceptor {
    public intercept(
        request: TRequestParameters<RequestInit, Body>,
        _requestOption: IRequestOptions<TJson>,
    ): TRequestParameters<RequestInit, Body> {
        const {body, options, url} = request;

        // Добавляем IP клиента только на сервере
        if (!isBrowserContext()) {
            const clientIp = getClientIpFromContext();

            if (clientIp) {
                return {
                    body,
                    options: {
                        ...options,
                        headers: {
                            ...(options?.headers ?? {}),
                            'X-Real-IP': clientIp,
                            'X-Forwarded-For': clientIp,
                        },
                    },
                    url,
                };
            }
        }

        return request;
    }
}
